import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import gql from 'graphql-tag';

import { GetVisitsWithOrgMembers } from '../../athena/types/GetVisitsWithOrgMembers';
import { VISIT_WITH_ORGANIZATION_FIELDS } from '../../fragments/trippy/visitWithOrganizationFields';

export const GET_VISITS_WITH_ORG_MEMBERS = gql`
  query GetVisitsWithOrgMembers($visitIds: [String!]!) {
    trippy {
      getVisits(input: { visitIds: $visitIds }) {
        visits {
          ...VisitWithOrganizationFields
        }
      }
    }
  }

  ${VISIT_WITH_ORGANIZATION_FIELDS}
`;

const useGetVisitsWithOrgMembers = (options?: QueryHookOptions<GetVisitsWithOrgMembers>) =>
  useQuery<GetVisitsWithOrgMembers>(GET_VISITS_WITH_ORG_MEMBERS, options);

export default useGetVisitsWithOrgMembers;
